import { writable } from 'svelte/store';

// create a writable store to hold the birth data
export const birthData = writable({
    name: 'naam',
    date: 'dd-mm-jjjj',
    time: 'uu:mm:ss',
    location: 'woonplaats',
    longitude: '0.000000',
    latitude: '0.000000',
    tzName: 'tijdzone',
    tzOffset: '0',
    utcDateStr: 'dd-mm-jjjj',
    utcTime: 'uu:mm:ss',
});